import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmbeddedRemoteApplicationComponent } from '@itero/ui-toolkit-angular/remote-application';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { PatientCardEditorId } from '@shared/models/consts';
import { distinctUntilChanged, endWith, takeUntil } from 'rxjs';
import { PatientCardFacade } from './patient-card.facade';

@Component({
	selector: 'rx-patient-card',
	template: '<tlk-embedded-remote-application [appId]="appId" [appParameters]="appParameters$ | async" />',
	standalone: true,
	imports: [CommonModule, AsyncPipe, EmbeddedRemoteApplicationComponent],
	providers: [PatientCardFacade],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientCardComponent extends BaseDestroyableComponent implements OnInit {
	@Input() appId: string = PatientCardEditorId;

	@Output() patientAppReadyChange = new EventEmitter<boolean>();

	private readonly isPatientAppReady$ = this.facade.isPatientAppReady$;
	readonly appParameters$ = this.facade.appParameters$;

	constructor(
		private readonly facade: PatientCardFacade,
		private readonly cdr: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void {
		this.facade
			.listenIncomingEvents()
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(() => this.cdr.markForCheck());

		this.isPatientAppReady$
			.pipe(distinctUntilChanged(), takeUntil(this.componentAlive$), endWith(false))
			.subscribe(isReady => this.patientAppReadyChange.emit(isReady));
	}
}
